class UserPictureDto {
    constructor(user, imagen) {
        this.user = user._id;
        this.imagen = imagen;
    }
}

export default UserPictureDto;
